import { createReduxStore } from '../../shared/utils/redux';
import { createMakeRequest } from '../client';
import { getHttpApi } from '@cian/http-api/browser';
import { getLogger } from '@cian/logger/browser';
import { getConfig } from '@cian/config/browser';

export const createApplicationState = () => {
  return createReduxStore({
    context: {
      makeRequest: createMakeRequest(window.__mainpage_api_host__ || window.location.host),
      httpApi: getHttpApi(),
      logger: getLogger(),
      config: getConfig(),
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } as any,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    initialState: window.__mainpage_state__ as any,
    debugEnabled: true,
  });
};
